import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getPayments, type GetPaymentsParams, type PaymentsResponse } from './api';

export function usePaymentsQuery(params: GetPaymentsParams) {
  return useQuery<PaymentsResponse>({
    queryKey: ['payments', params],
    queryFn: () => getPayments(params),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}
